import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Event } from './../Event';

var debug = require('debug')('CRATE:Communication:TextManager:TextEvent');

export var TextEvent =
/*#__PURE__*/
function (_Event) {
  _inherits(TextEvent, _Event);

  function TextEvent(opts) {
    var _this;

    _classCallCheck(this, TextEvent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextEvent).call(this, opts));
    _this._communicationChannel = _this._document._communication._data_comm;
    _this._sequence = _this._document.sequence;
    return _this;
  }

  _createClass(TextEvent, [{
    key: "getLSEQID",
    value: function getLSEQID(_ref) {
      var pair = _ref.pair,
          id = _ref.id;
      var LSEQID = id;
      if (pair) LSEQID = pair.id;
      var idForCausal = {
        e: LSEQID._s[LSEQID._s.length - 1],
        c: LSEQID._c[LSEQID._c.length - 1]
      };
      return idForCausal;
    }
  }]);

  return TextEvent;
}(Event);